import { OptionCl } from "../../../components/select-cl";
import { Dispatch } from "redux";


export const DEPO_TYPE_DOMAIN = "DTYPE"

export type DepoType = {
    name: string
}

const prepareDepoTypes  = ( response : DepoType[]   ) => {
    const opts: OptionCl[] = response.map( (dType : DepoType) => ({
        id : dType.name,
        description: dType.name
    })
    )
    return opts;
}


// depository cities for the depository dropdown
export const fetchDepoTypes = (
    dispatch : Dispatch<any>,
    componentType: "DepositoryCriteria"
) => {
    const depoTypes : DepoType[] = [
        {name: "COMMON"},
        {name: "CSK"},
        {name: "CSP"},
        {name: "CTA"},
        {name: "DOMESTIC"},
        {name: "EURO"}
    ]
    dispatch({type: componentType + "/DOMAINLOADED", payload: prepareDepoTypes(depoTypes), domain: DEPO_TYPE_DOMAIN })
}
